import { Link, Navigate, useParams } from "react-router-dom";
import { blogItems } from "../../components/blog/blogData";
import "./BlogPost.scss";

const formatDate = (date: string) =>
  new Intl.DateTimeFormat("pt-BR", {
    day: "2-digit",
    month: "long",
    year: "numeric",
  }).format(new Date(`${date}T12:00:00`));

const BlogPost = () => {
  const { id } = useParams<{ id: string }>();
  const post = blogItems.find((item) => item.id === id);

  if (!post) {
    return <Navigate to="/blog" replace />;
  }

  return (
    <article className="blog-post">
      <header className="blog-post__header">
        <img className="blog-post__cover" src={post.imageUrl} alt={post.title} />
        <div className="blog-post__heading">
          <Link to="/blog" className="blog-post__back-link">
            Voltar para o blog
          </Link>
          <h1>{post.title}</h1>
          <div className="blog-post__meta">
            <span>Por {post.author}</span>
            <span aria-hidden="true">•</span>
            <time dateTime={post.createdAt}>{formatDate(post.createdAt)}</time>
            <span aria-hidden="true">•</span>
            <span>{post.readingTime} min de leitura</span>
          </div>
        </div>
      </header>

      <div className="blog-post__body">
        <div className="blog-post__content">
          <div dangerouslySetInnerHTML={{ __html: post.contentHtml }} />
        </div>
      </div>
    </article>
  );
};

export default BlogPost;
